import React from 'react';
import { Space, Typography, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { CrmAuditFields } from '../../api/CRMApiClient';
import { formatHistoryDate } from '../../helpers/crmHistoryFormat';

const { Text } = Typography;

interface Props {
  record?: CrmAuditFields | null;
}

/** "Created by X on D · Updated by Y on D" line for detail pages. Hidden for records without stamps. */
const CrmAuditInfo: React.FC<Props> = ({ record }) => {
  const { t } = useTranslation();
  if (!record?.createdAt && !record?.updatedAt) return null;

  return (
    <Space split={<Divider type="vertical" />} wrap style={{ marginBottom: 12 }}>
      {record.createdAt && (
        <Text type="secondary">
          {t('CreatedBy')}: {record.createdByName || t('Unknown')} · {formatHistoryDate(record.createdAt)}
        </Text>
      )}
      {record.updatedAt && (
        <Text type="secondary">
          {t('UpdatedBy')}: {record.updatedByName || t('Unknown')} · {formatHistoryDate(record.updatedAt)}
        </Text>
      )}
    </Space>
  );
};

export default CrmAuditInfo;
